import { cloneDeep } from 'lodash';
import { JsonObject } from '../helpers';
import { NosqlDocModel } from './nosql-doc.model';

export type BaseMeta = {
  id: string;
};

export class BaseModel extends NosqlDocModel {
  get _json(): JsonObject {
    const json: JsonObject = {};
    Object.getOwnPropertyNames(this).map((prop: string) => (json[prop] = this[prop as keyof this]));
    return JSON.parse(JSON.stringify(json)) as JsonObject;
  }

  get _props(): Record<string, unknown> {
    const props: Record<string, unknown> = {};
    Object.getOwnPropertyNames(this).map(
      (prop: string) => (props[prop] = this[prop as keyof this])
    );
    return cloneDeep(props);
  }
}

export class CreateBaseModel {
  get _props(): Record<string, unknown> {
    const props: Record<string, unknown> = {};
    const protectedFields = ['schema'];

    Object.getOwnPropertyNames(this)
      .filter((propName) => {
        if (protectedFields.includes(propName)) {
          return false;
        }
        const descriptor = Object.getOwnPropertyDescriptor(this, propName);
        return descriptor && typeof descriptor.get !== 'function';
      })
      .forEach((prop: string) => (props[prop] = this[prop as keyof this]));

    return props;
  }
}
